export default "__VITE_ASSET__7zAaCM$d__"